import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { rootRoute } from 'root/RootLayout';

export const logoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'logout',
  component: lazyRouteComponent(() => import('./LogoutView')),
});
